import { getUserAvatar } from '@/common/utils/image';
import { TPerson } from '@/common/basis/types/database/tperson';

function App(props: { list: TPerson.User[] }) {
  const list = props.list;

  return (
    <>
      {list.map((value) => (
        <div className='w-12 overflow-hidden p-1 font-medium' key={value?.userId}>
          <div className='mx-auto h-12 w-12 overflow-hidden rounded-lg'>
            <img className='h-full w-full object-cover' src={getUserAvatar(value?.avatar)} />
          </div>
          <div className='mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-center font-normal leading-6 text-[#888]'>
            <span>{value?.userName}</span>
          </div>
        </div>
      ))}
    </>
  );
}

export default App;
